export default "__VITE_ASSET__d85ab743__"